// Central SEO metadata for every route in the site.
// Add a new entry here whenever you add a new page.
// Use Dutch, keyword-rich titles and descriptions.

export const SEO = {
  home: {
    title: "EquiSight — Ultimate Horse App | paarden management voor training, gezondheid & wedstrijden",
    description:
      "EquiSight is dé paarden app voor eigenaren, manegeruiters, trainers en professionals. Beheer gezondheid, training, voeding, planning, wedstrijdanalyse en samenwerk in één paardendossier.",
    keywords: [
      "paarden app",
      "paarden management app",
      "app voor paarden",
      "paarden administratie",
      "paardendossier app",
      "paarden gezondheidsdossier",
      "paarden agenda",
      "wedstrijdanalyse paard",
    ],
    image: "/assets/owner-horse.png",
  },

  functiesIndex: {
    title: "Functies — alles wat EquiSight kan | paarden app",
    description:
      "Ontdek alle functies van EquiSight: paardendossier, wedstrijdanalyse, hoefsmid log, agenda, voedingsadvies, medicatie, fokkerij, ontworming, entingen en meer.",
    keywords: [
      "paarden app functies",
      "paarden management functies",
      "wedstrijdanalyse",
      "paarden agenda",
      "paardendossier",
    ],
  },

  doelgroepenIndex: {
    title: "Voor wie is EquiSight? Doelgroepen | paarden app",
    description:
      "EquiSight is gemaakt voor paardeneigenaren, manegehouders, wedstrijdruiters, dressuur- en springruiters, fokkers, trainers, hoefsmeden en dierenartsen.",
    keywords: [
      "app voor paardeneigenaren",
      "app voor manegehouders",
      "app voor wedstrijdruiters",
      "app voor fokkers",
      "app voor trainers",
    ],
  },

  kennisbankIndex: {
    title: "Kennisbank paarden — alles over gezondheid, voeding & training",
    description:
      "De EquiSight kennisbank: heldere artikelen over paardengezondheid, voeradvies, hoefverzorging, entingen, koliek, droes, zomereczeem en meer. Informatief — geen veterinair advies.",
    keywords: [
      "paardengezondheid",
      "voeradvies paard",
      "ontwormingsschema paard",
      "entingen paard",
      "koliek paard",
      "fructaan index",
    ],
  },

  support: {
    title: "Support — hulp en contact | EquiSight",
    description:
      "Hulp nodig met EquiSight? Stel je vraag, bekijk veelgestelde vragen of mail naar support@equisight.nl. We helpen je snel op weg.",
    keywords: ["equisight support", "paarden app hulp", "equisight contact"],
  },

  faq: {
    title: "Veelgestelde vragen — EquiSight paarden app",
    description:
      "Antwoorden op de meest gestelde vragen over EquiSight: hoeveel kost het, hoe begin ik, werkt het op iPhone en Android, hoe veilig is mijn data, en meer.",
    keywords: ["equisight faq", "paarden app vragen", "veelgestelde vragen equisight"],
  },

  downloads: {
    title: "Downloads — gratis checklists & templates | EquiSight",
    description:
      "Gratis downloads voor paardeneigenaren: noodnummers checklist, voederplan template, ontwormingsschema, vaccinatiekalender en meer. Direct te downloaden.",
    keywords: [
      "checklist paard",
      "voederplan paard",
      "ontwormingsschema download",
      "vaccinatiekalender paard",
    ],
  },

  blog: {
    title: "Blog — paardenkennis & EquiSight nieuws",
    description:
      "Lees onze blog over paardenbeheer, gezondheid, training, wedstrijden en EquiSight productupdates. Praktische tips voor iedere ruiter en paardeneigenaar.",
    keywords: ["paarden blog", "equisight nieuws", "paardenkennis blog"],
  },

  vergelijkingen: {
    title: "Vergelijkingen — EquiSight versus alternatieven",
    description:
      "Hoe verhoudt EquiSight zich tot Excel, andere paarden apps en spreadsheets? Bekijk eerlijke vergelijkingen en kies wat bij jou past.",
    keywords: ["equisight vs", "paarden app vergelijken", "beste paarden app"],
  },

  privacy: {
    title: "Privacyverklaring — EquiSight",
    description: "Hoe wij omgaan met jouw gegevens. Lees onze volledige privacyverklaring.",
  },
  voorwaarden: {
    title: "Algemene voorwaarden — EquiSight",
    description: "De algemene voorwaarden van EquiSight.",
  },
  cookies: {
    title: "Cookiebeleid — EquiSight",
    description: "Welke cookies EquiSight gebruikt en hoe je je voorkeuren beheert.",
  },

  // FUNCTIES — 16 feature pages
  functies: {
    wedstrijdanalyse: {
      title: "Wedstrijdanalyse paard — protocol scannen & EPI | EquiSight",
      description:
        "Upload je dressuurprotocol, krijg automatisch scores per onderdeel, jurycommentaar en trends. Begrijp waar je punten laat liggen en word beter met de Equestrian Performance Index.",
      keywords: [
        "wedstrijdanalyse paard",
        "dressuurprotocol analyseren",
        "KNHS uitslagen app",
        "dressuur app",
        "wedstrijdresultaten paard",
      ],
    },
    hoefsmid: {
      title: "Hoefsmid app — agenda, dossier & klant communicatie | EquiSight",
      description:
        "Hoefsmid software met agenda, klantbeheer, voor- en na foto's, ETA notificaties en behandelhistorie. Professioneler werken, minder miscommunicatie.",
      keywords: ["hoefsmid app", "hoefsmid software", "hoefsmid planning paard"],
    },
    dierenarts: {
      title: "Dierenarts module — paardendossier & afspraken | EquiSight",
      description:
        "Bouw een compleet medisch dossier per paard: vaccinaties, medicatie, bevindingen, foto's en historie. Werk samen met de eigenaar en andere professionals.",
      keywords: ["dierenarts paard app", "paard medisch dossier", "paard vaccinatie app"],
    },
    trainer: {
      title: "Trainer app — coaching, doelen & voortgang | EquiSight",
      description:
        "Voor instructeurs en trainers met meerdere ruiters: zet doelen, geef feedback, volg progressie en analyseer wedstrijdprotocollen.",
      keywords: ["trainer app paard", "instructeur app", "ruiter coaching app"],
    },
    fokkerij: {
      title: "Fokkerij software paard — cyclus, dracht & veulens | EquiSight",
      description:
        "Beheer alles rond merries en fokkerij: hengstigheid, inseminatiedata, drachtcontroles, echo's, stamboom en veulenontwikkeling.",
      keywords: [
        "fokkerij software paard",
        "merrie cyclus app",
        "dracht paard berekenen",
        "hengstigheid tracker paard",
        "inseminatie planning paard",
      ],
    },
    tandarts: {
      title: "Paardentandarts module — gebitscontrole & dossier | EquiSight",
      description:
        "Registreer gebitscontroles, behandelingen, foto's en opvolging in één paardendossier. Eenvoudig delen met de eigenaar.",
      keywords: ["paardentandarts app", "tandarts paard registratie", "gebitscontrole paard"],
    },
    manege: {
      title: "Manege software — administratie, lessen & paardenbeheer | EquiSight",
      description:
        "Manege software voor lesplanning, ruiter administratie, paardenbeheer en communicatie. Maak je manege digitaal toegankelijk voor iedere ruiter.",
      keywords: [
        "manege software",
        "paarden administratie manege",
        "manege planning software",
        "lessen planning paarden",
        "ruiter registratie manege",
      ],
    },
    voeding: {
      title: "Voeding paard app — voederplan, advies & overzicht | EquiSight",
      description:
        "Maak een persoonlijk voederplan per paard. EquiCoach geeft voederadvies op basis van gewicht, werk, leeftijd en fructaan-index.",
      keywords: ["voeding paard app", "voederplan paard", "voeradvies paard"],
    },
    medicatie: {
      title: "Medicatie paard app — registreren & herinneringen | EquiSight",
      description:
        "Houd alle medicatie per paard bij. Doseringen, frequentie, einddatum, paspoortvermelding en herinneringen.",
      keywords: ["medicatie paard app", "paard medicatie registreren", "paard medicijnen bijhouden"],
    },
    agenda: {
      title: "Paarden agenda — afspraken, herinneringen & planning | EquiSight",
      description:
        "Een centrale paarden agenda met afspraken, herinneringen voor ontworming, entingen, hoefsmid en wedstrijden. Push-meldingen op je telefoon.",
      keywords: ["paarden agenda", "paard planning app", "paard kalender app"],
    },
    "protocol-analyse": {
      title: "Protocol analyse dressuur — voor- en achterkant scannen | EquiSight",
      description:
        "Scan je dressuurprotocol (KNHS, FEI) en krijg direct inzicht in scores, jurycommentaar en trends. Vergelijk meerdere protocollen per paard-ruiter combinatie.",
      keywords: [
        "dressuur protocol analyseren",
        "protocol analyse dressuur",
        "KNHS protocol app",
        "jury analyse dressuur",
      ],
    },
    noodnummers: {
      title: "Noodnummers paard — direct bellen, WhatsAppen, navigeren | EquiSight",
      description:
        "Altijd alle noodcontacten bij de hand: dierenarts, kliniek, hoefsmid, fysio. Eén tik en je belt, appt of navigeert. Altijd gratis in EquiSight.",
      keywords: [
        "noodnummers paard",
        "noodnummer dierenarts",
        "paard koliek dierenarts bellen",
        "spoednummer paard",
      ],
    },
    weidegang: {
      title: "Weidegang paard — bijhouden, tijden & fructaan-index | EquiSight",
      description:
        "Volg de weidegang van je paard: tijden, kwaliteit, fructaan-index waarschuwingen en wisselende rotaties. Voorkom hoefbevangenheid.",
      keywords: ["weidegang paard", "fructaan index paard", "weide paard app"],
    },
    entingen: {
      title: "Entingen paard bijhouden — vaccinatiekalender | EquiSight",
      description:
        "Houd alle entingen per paard bij met automatische herinneringen voor influenza, tetanus, west-nijl en rhinopneumonie. Nooit meer een vaccinatie missen.",
      keywords: [
        "entingen paard bijhouden",
        "paarden entingen",
        "vaccinatie paard app",
        "vaccinatiekalender paard",
      ],
    },
    ontwormen: {
      title: "Ontwormen paard — schema, EPG & herinneringen | EquiSight",
      description:
        "Persoonlijk ontwormingsschema per paard, op basis van EPG-tests en seizoen. Krijg op tijd herinnering en houd de historie bij.",
      keywords: [
        "ontworming paard schema",
        "ontwormingsschema paard",
        "EPG paard",
        "paard ontwormen app",
      ],
    },
    "gewicht-monitoring": {
      title: "Gewicht paard monitoren — meten, trend & advies | EquiSight",
      description:
        "Houd het gewicht en de conditie van je paard bij in een trendgrafiek. Krijg waarschuwingen bij afwijkingen en koppel direct aan voederplan.",
      keywords: ["gewicht paard bijhouden", "conditie paard meten", "paard wegen app"],
    },
  },

  // DOELGROEPEN — 9 audience pages
  doelgroepen: {
    paardeneigenaren: {
      title: "Paarden app voor paardeneigenaren | EquiSight",
      description:
        "EquiSight is dé app voor paardeneigenaren: één dossier per paard met gezondheid, training, voeding, agenda en samenwerking met hoefsmid, dierenarts en trainer.",
      keywords: ["app voor paardeneigenaren", "paard administratie", "paardendossier"],
    },
    manegehouders: {
      title: "Manege software voor manegehouders | EquiSight",
      description:
        "Maak je manege digitaal: lesplanning, ruiter administratie, paardenbeheer en communicatie. Meer binding met ruiters, professioneler werken.",
      keywords: ["manege software", "manege administratie", "manegehouder app"],
    },
    wedstrijdruiters: {
      title: "App voor wedstrijdruiters — protocol & EPI | EquiSight",
      description:
        "Voor wedstrijdruiters: analyseer protocollen, volg de Equestrian Performance Index, plan wedstrijden en deel resultaten met je trainer.",
      keywords: ["app voor wedstrijdruiters", "paard wedstrijd planning", "wedstrijdresultaten paard"],
    },
    dressuurruiters: {
      title: "Dressuur app — protocol analyse & coaching | EquiSight",
      description:
        "Voor dressuurruiters: scan je protocol, krijg inzicht in scores per onderdeel, jurycommentaar en trends. Word beter met data.",
      keywords: ["dressuur app", "dressuurprotocol analyseren", "KNHS uitslagen"],
    },
    springruiters: {
      title: "App voor springruiters — startlijsten, planning & training | EquiSight",
      description:
        "Voor springruiters: plan wedstrijden, ontvang startlijst meldingen, registreer rondes en volg training en gezondheid van je paarden.",
      keywords: ["app voor springruiters", "springen app paard", "startlijst meldingen paard"],
    },
    fokkers: {
      title: "Fokkerij software voor fokkers | EquiSight",
      description:
        "Voor fokkers en merriehouders: cyclus, hengstigheid, dekkingen, dracht, stamboom en veulenontwikkeling — alles in één systeem.",
      keywords: [
        "fokkerij software paard",
        "merrie cyclus app",
        "fokker app paard",
        "dracht paard berekenen",
      ],
    },
    hoefsmeden: {
      title: "Hoefsmid app voor hoefsmeden | EquiSight",
      description:
        "Voor hoefsmeden: agenda, klantbeheer, voor- en na foto's, ETA notificaties en behandelhistorie. Werk professioneler.",
      keywords: ["hoefsmid app", "hoefsmid software"],
    },
    dierenartsen: {
      title: "App voor paarden dierenartsen | EquiSight",
      description:
        "Voor paarden dierenartsen: medisch dossier per paard, behandelhistorie, vaccinaties, medicatie en directe communicatie met de eigenaar.",
      keywords: ["dierenarts paard app", "paard medisch dossier app"],
    },
    trainers: {
      title: "Trainer app voor instructeurs | EquiSight",
      description:
        "Voor trainers en instructeurs: zet doelen per combinatie, geef feedback, volg progressie en analyseer protocollen — voor één of meerdere ruiters.",
      keywords: ["trainer app paard", "instructeur app"],
    },
  },

  // KENNISBANK — knowledge base articles (Phase 2 will expand these)
  kennisbank: {
    "paarden-gezondheid": {
      title: "Paardengezondheid — complete gids | EquiSight kennisbank",
      description:
        "Wat houdt paardengezondheid in? Lees alles over signalen, preventie, dossier, controles en samenwerken met je dierenarts.",
      keywords: ["paardengezondheid", "paard gezond houden", "paardengezondheid signalen"],
    },
    voeradvies: {
      title: "Voeradvies paard — basisregels en valkuilen | EquiSight",
      description:
        "Hoe stel je een goed voederplan op voor je paard? Hooi, krachtvoer, supplementen, gewicht en de fructaan-index uitgelegd.",
      keywords: ["voeradvies paard", "voederplan paard", "paard krachtvoer"],
    },
    "hoefverzorging": {
      title: "Hoefverzorging paard — wat je moet weten | EquiSight",
      description:
        "Beksnijden, beslag, ijsbedden, hoefkwaliteit en hoe vaak de hoefsmid moet komen. Alles over hoefverzorging op één plek.",
      keywords: ["hoefverzorging paard", "paard hoefsmid", "hoefkwaliteit paard"],
    },
    entingen: {
      title: "Entingen paard — schema, soorten en regels | EquiSight",
      description:
        "Welke entingen heeft een paard nodig? Influenza, tetanus, rhinopneumonie en west-nijl. Schema's en KNHS regels uitgelegd.",
      keywords: ["paarden entingen", "vaccinatie paard", "influenza vaccinatie paard"],
    },
    "fructaan-index": {
      title: "Fructaan-index paard — wat het is en hoe je het gebruikt | EquiSight",
      description:
        "Wat is de fructaan-index? Wanneer is gras gevaarlijk voor je paard? Hoe voorkom je hoefbevangenheid met data en planning.",
      keywords: ["fructaan index paard", "gras paard hoefbevangenheid", "fructaan gras"],
    },
    koliek: {
      title: "Koliek paard — symptomen, oorzaken & wat te doen | EquiSight",
      description:
        "Hoe herken je koliek bij je paard? Symptomen, mogelijke oorzaken, eerste hulp en wanneer je 112 voor paarden belt.",
      keywords: ["koliek paard", "paard koliek symptomen", "wat te doen bij koliek"],
    },
    droes: {
      title: "Droes paard — symptomen, besmetting & isolatie | EquiSight",
      description:
        "Droes (strangles) bij paarden: herkennen, voorkomen, isoleren en behandelen. Wat te doen op een besmette stal.",
      keywords: ["droes paard", "strangles paard", "droes symptomen paard"],
    },
    zomereczeem: {
      title: "Zomereczeem paard — preventie & behandeling | EquiSight",
      description:
        "Zomereczeem bij paarden: oorzaak, symptomen, dekens, voeding en preventie tegen kriebelmugjes.",
      keywords: ["zomereczeem paard", "paard kriebelmug", "zomereczeem behandeling"],
    },
  },

  // PROGRAMMATIC SEO clusters
  paardenrassen: {
    "fries-paard": {
      title: "Fries paard — kenmerken, geschiedenis & verzorging | EquiSight",
      description:
        "Alles over het Friese paard: rasstandaard, karakter, verzorging, gezondheidspunten en waarom EquiSight perfect bij dit ras past.",
      keywords: ["fries paard", "friese paard kenmerken", "friese paard verzorging"],
    },
    kwpn: {
      title: "KWPN — Nederlands Warmbloed paard | EquiSight",
      description:
        "Het KWPN paard: stamboek, prestaties in dressuur en springen, karakter en hoe je een KWPN paard digitaal beheert.",
      keywords: ["KWPN paard", "Nederlands Warmbloed", "KWPN dressuur springen"],
    },
    "arabisch-volbloed": {
      title: "Arabisch Volbloed paard — kenmerken & verzorging | EquiSight",
      description:
        "Het Arabisch Volbloed (Arab): rasstandaard, endurance, karakter en verzorgingspunten.",
      keywords: ["arabisch volbloed", "arab paard", "endurance paard"],
    },
    "shetland-pony": {
      title: "Shetland pony — kenmerken, voeding & verzorging | EquiSight",
      description:
        "De Shetland pony: rasstandaard, voedingsvalkuilen (hoefbevangenheid), verzorging en hoe EquiSight helpt.",
      keywords: ["shetland pony", "pony hoefbevangenheid", "shetlander verzorging"],
    },
    haflinger: {
      title: "Haflinger paard — kenmerken & verzorging | EquiSight",
      description:
        "De Haflinger: rasstandaard, gebruik, karakter en verzorgingspunten.",
      keywords: ["haflinger paard", "haflinger kenmerken"],
    },
  },

  aandoeningen: {
    koliek: {
      title: "Koliek paard — symptomen & wat te doen | EquiSight aandoeningen",
      description:
        "Koliek bij paarden uitgelegd. Symptomen, mogelijke oorzaken, behandeling en wanneer je de dierenarts belt.",
      keywords: ["koliek paard", "paard koliek symptomen"],
    },
    hoefbevangenheid: {
      title: "Hoefbevangenheid (laminitis) — preventie & behandeling | EquiSight",
      description:
        "Hoefbevangenheid herkennen, voorkomen en behandelen. Risicofactoren, voeding en weidegang.",
      keywords: ["hoefbevangenheid paard", "laminitis paard", "hoefkatar"],
    },
    droes: {
      title: "Droes (strangles) — herkennen & isoleren | EquiSight",
      description:
        "Droes is zeer besmettelijk. Lees over symptomen, isolatieprotocol en behandeling.",
      keywords: ["droes paard", "strangles paard"],
    },
    "west-nijl": {
      title: "West-Nijl virus paard — vaccinatie & symptomen | EquiSight",
      description:
        "West-Nijl bij paarden: symptomen, vaccinatiebeleid in Nederland en preventie.",
      keywords: ["west-nijl paard", "west nile virus paard"],
    },
    rhinopneumonie: {
      title: "Rhinopneumonie paard — vaccinatie & uitbraak | EquiSight",
      description:
        "Rhinopneumonie (EHV): symptomen, vaccinatie en wat te doen bij een uitbraak op stal.",
      keywords: ["rhinopneumonie paard", "EHV paard"],
    },
    zomereczeem: {
      title: "Zomereczeem — preventie & behandeling paard | EquiSight",
      description:
        "Zomereczeem bij paarden uitgelegd: oorzaak, symptomen en preventie.",
      keywords: ["zomereczeem paard"],
    },
  },

  entingen_routes: {
    "influenza-paard": {
      title: "Influenza paard — vaccinatieschema | EquiSight",
      description:
        "Paardeninfluenza vaccinatie: schema, KNHS regels en hoe je het bijhoudt in EquiSight.",
      keywords: ["influenza paard", "influenza vaccinatie paard", "KNHS vaccinatie"],
    },
    "tetanus-paard": {
      title: "Tetanus paard — vaccinatie & herhaling | EquiSight",
      description:
        "Tetanusvaccinatie voor paarden: noodzaak, frequentie en hoe je het registreert.",
      keywords: ["tetanus paard", "tetanus vaccinatie paard"],
    },
    "rhinopneumonie-paard": {
      title: "Rhinopneumonie vaccinatie paard | EquiSight",
      description:
        "Vaccinatie tegen rhinopneumonie (EHV-1/4): schema en advies.",
      keywords: ["rhinopneumonie vaccinatie", "EHV vaccinatie paard"],
    },
    "west-nijl-paard": {
      title: "West-Nijl vaccinatie paard | EquiSight",
      description:
        "West-Nijl vaccinatie voor paarden: wanneer, hoe vaak en KNHS aanbevelingen.",
      keywords: ["west-nijl vaccinatie paard"],
    },
  },

  ontworming: {
    "schema-paard": {
      title: "Ontwormingsschema paard — slim & op basis van EPG | EquiSight",
      description:
        "Modern ontwormingsschema op basis van EPG-tests. Voorkom resistentie en houd je paard wormvrij.",
      keywords: ["ontwormingsschema paard", "ontworming paard schema", "EPG paard"],
    },
    "epg-paard": {
      title: "EPG test paard — eitjes per gram meten | EquiSight",
      description:
        "Wat is EPG, hoe werkt het en waarom is selectief ontwormen beter dan blind alle paarden ontwormen?",
      keywords: ["EPG paard", "eitjes per gram paard", "selectief ontwormen paard"],
    },
  },

  disciplines: {
    dressuur: {
      title: "Dressuur — app, protocol & training | EquiSight",
      description:
        "Alles over dressuur in EquiSight: protocol analyse, EPI, doelen, jurycommentaar en trainingsplanning.",
      keywords: ["dressuur app", "dressuurprotocol", "dressuur training paard"],
    },
    springen: {
      title: "Springen — app, planning & training | EquiSight",
      description:
        "Springruiters: wedstrijdplanning, startlijst meldingen, rondes registreren en trainingsanalyse.",
      keywords: ["springen app", "spring planning paard"],
    },
    eventing: {
      title: "Eventing — app & planning | EquiSight",
      description:
        "Eventing/Military: dressuur, cross en springen in één planning. EquiSight helpt je organiseren.",
      keywords: ["eventing app", "military paard app"],
    },
    endurance: {
      title: "Endurance — app & training | EquiSight",
      description:
        "Endurance ruiters: trainingsplanning, voeding, hartslag, hersteltijden en logboek.",
      keywords: ["endurance app paard", "duurrit paard"],
    },
    western: {
      title: "Western — app & training | EquiSight",
      description:
        "Western disciplines: training, gezondheid en wedstrijden bijhouden voor reining, trail, pleasure en meer.",
      keywords: ["western paard app", "reining paard"],
    },
  },
};

export default SEO;
